import { createFileRoute } from '@tanstack/react-router'
import { EditMedicationPage } from '_/features/pets/ui/pages/edit-medication-page'

const EditMedicationRoute = () => {
	const { petId, medicationId } = Route.useParams()
	return <EditMedicationPage petId={petId} medicationId={medicationId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/medications/$medicationId/edit')({
	staticData: { title: 'medications_edit_title' },
	component: EditMedicationRoute,
})
